import { render } from "./Header.vue?vue&type=template&id=473376f4"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "473376f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('473376f4', __exports__)) {
    api.reload('473376f4', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=473376f4", () => {
    api.rerender('473376f4', render)
  })

}


export default __exports__